'use strict';

import angular from 'angular';
import ResetPasswordController from './reset-password.controller';

export default angular.module('conduuApp.resetPassword', [])
  .controller('ResetPasswordController', ResetPasswordController)
  .name;



// WEBPACK FOOTER //
// ./client/app/account/reset-password/index.js